import { getFormattedCloudinaryUrl } from "@swiggy-private/js-utils"
import { ImageKitOptions } from "interfaces/imagekit";

export const getImageKitUrl = <T extends string | undefined>(
    filename: T,
    options: ImageKitOptions = {},
): T extends undefined | "" ? undefined : string => {
    if (!filename) {
        return undefined as any;
    }

    const params = ["fl_lossy"];

    if (options.format) {
        params.push(`f_${options.format}`);
    } else {
        params.push("f_auto");
    }

    params.push("q_auto");

    if (options.width && options.width > 0) {
        params.push(`w_${options.width}`);
    }

    if (options.height && options.height > 0) {
        params.push(`h_${options.height}`);
    }

    if (options.radius && options.radius > 0) {
        params.push(`r_${options.radius}`);
    } else if (options.circular) {
        params.push("r_max");
    }

    if (options.centerScale) {
        params.push("c_scale");
    }

    if (options.trim) {
        params.push("e_trim");
    }

    if (options.grayscale) {
        params.push("e_grayscale");
    }

    if (options.fill) {
        params.push("c_fill");
    }

    if (options.fit) {
        params.push("c_fit");
    }

    if (options.shadow && options.shadow.e && options.shadow.e > 0) {
        const shadowParams = [];
        shadowParams.push(`e_shadow:${options.shadow.e}`);

        if (typeof options.shadow.x === "number") {
            shadowParams.push(`x_${options.shadow.x}`);
        }
        if (typeof options.shadow.y === "number") {
            shadowParams.push(`y_${options.shadow.y}`);
        }
        if (options.shadow.colorRGB) {
            shadowParams.push(`co_rgb:${options.shadow.colorRGB}`);
        }

        params.push(...shadowParams);
    }

    return getFormattedCloudinaryUrl(
        `influencer-app-assets/${filename}`,
        `https://driver-media-assets.swiggy.com/drivers`,
        params,
        { keepExtension: true },
    ) as T extends undefined | "" ? undefined : string;
};

